import React from 'react'
import { Config } from '@chegg-wt/core/config'
import { publicAssetUrl } from '@chegg-wt/core/utils/url'
import { UpsellCopy } from '@chegg-wt/core/types/features'
import { connect } from 'react-redux'
import {
  origins,
  UserClickPayload,
} from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { AppRoute } from '@chegg-wt/core/types/core'
import { userClick } from '@chegg-wt/core/state/instrumentation/actions'
import TermsAndConditionsLink from '../TermsAndConditionsLink'
import AppLink from '../AppLink'
import { FeatureItem } from './FeatureItem'
import {
  PlagiarismContainer,
  H2,
  GPContentWrapper,
  PlagiarizedPaperImage,
  GPFeatureWrapper,
  FeatureListContainer,
  CTAButton,
  TermsWrapper,
  CTAContainer,
} from './styles'
import { GP_CTA, GP_UPSELL_ITEM, GP_UPSELL, TC_LINK } from './testIds'

interface PlagiarismUpsellCardProps {
  route: AppRoute
  copy: UpsellCopy
  userClick: (payload: UserClickPayload) => void
}

const toFeatureItems = (text, index) => (
  <FeatureItem key={text} featureText={text} testId={`${GP_UPSELL_ITEM}_${index}`} />
)

export const PlagiarismUpsellCard: React.FC<PlagiarismUpsellCardProps> = ({
  route,
  copy,
  userClick,
}) => {
  const { FEATURE_LIST, CTA_COPY, UPSELL_HEADING, IMAGE_ALT_TEXT } = copy

  const handleclick = () => {
    userClick({ origin: origins.plagiarismUpsellCardCTA, name: CTA_COPY })
  }
  return (
    <PlagiarismContainer data-test={GP_UPSELL}>
      <H2>{UPSELL_HEADING}</H2>
      <GPContentWrapper>
        <PlagiarizedPaperImage
          src={publicAssetUrl('plagiarism-paper.svg')}
          alt={IMAGE_ALT_TEXT}
        />
        <GPFeatureWrapper>
          <FeatureListContainer>{FEATURE_LIST.map(toFeatureItems)}</FeatureListContainer>
          <CTAContainer>
            <AppLink route={route}>
              <CTAButton
                forwardedAs="a"
                data-test={GP_CTA}
                aria-label={CTA_COPY}
                onClick={handleclick}
              >
                {CTA_COPY}
              </CTAButton>
            </AppLink>
            <TermsWrapper>
              <TermsAndConditionsLink
                href={Config.trialTermsAndConditionsUrl}
                testId={TC_LINK}
              />
            </TermsWrapper>
          </CTAContainer>
        </GPFeatureWrapper>
      </GPContentWrapper>
    </PlagiarismContainer>
  )
}

const mapDispatchToProps = {
  userClick,
}

export default connect(null, mapDispatchToProps)(PlagiarismUpsellCard)
